<template>
  <section v-if="me" id="section__register-account" class="layout-container">
    <div class="view-container">
      <v-card flat class="pa-0" width="100%">
        <v-card-title class="justify-center" style="flex-direction: column">
          <p class="font--m-1 mb-3">계좌 등록</p>
        </v-card-title>
        <v-expansion-panels flat class="mt-2 mb-5">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font--m-9 color--buynow"
                >왜 계좌 등록이 필요한가요?</span
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <p class="font--m-5">
                연동한 쇼핑몰에서 매출 금액이 입금되면 사용하신 금액과 수수료를 제외하고 차액 발생
                시 고객님의 계좌로 즉시 반환해 드리고 있어요.
                <b>계좌는 반드시 대표자 본인 계좌로 등록해 주세요.</b>
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" class="mb-5">
              <FindAccountName />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </section>
</template>

<script>
import FindAccountName from '@/components/auth/FindAccountName.vue'
import { mapState } from 'vuex'

export default {
  components: {
    FindAccountName,
  },
  computed: {
    ...mapState('auth', ['me']),
  },
}
</script>

<style lang="scss" scoped>
.view-container {
  padding-top: 3rem;
}
</style>
